import { render, staticRenderFns } from "./CommonProperty.vue?vue&type=template&id=3276a7f8&scoped=true&"
import script from "./CommonProperty.vue?vue&type=script&lang=js&"
export * from "./CommonProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276a7f8",
  null
  
)

export default component.exports